<div id="view-document" [hidden]="!isCheckAccessToContract || !isCheckAccessToConfirmContract" style="overflow: hidden">
  <div class="row">
    <div [ngClass]="{ 'col-lg-5 ': !isFullviewPdf }" [hidden]="isFullviewPdf" class="col-md-12 col-sm-12 pr-0">
      <div #focus tabindex="-1" class="card mat-card-content-contract-sm" style="
          height: calc(100vh - 140px);
          overflow-y: scroll;
          border-radius: unset !important;
          padding-bottom: 50px;
        ">
        <app-panel-document-view [documentTypeEnterprise]="documentTypeEnterprise" (navigate)="onBackClick()"></app-panel-document-view>
        <!--        <app-panel-setup-sign-flow-receive [documentInfo]="document" *ngIf="isSetupSignFlow" ></app-panel-setup-sign-flow-receive>-->
      </div>
    </div>
    <div [ngClass]="{ 'col-lg-7 ': !isFullviewPdf, 'col-lg-12': isFullviewPdf }" class="col-md-12 col-sm-12 view-pdf"
      [class.pl-0]="!isFullviewPdf" [class.mobile-hidden]="!isFullviewPdf" style="padding-right: 0.75rem">
      <div class="mat-elevation-z0 border-bottom" #headerControll [ngStyle]="{
          background:
            document.typeId === 1 &&
            document.mainContractAttachments &&
            document.mainContractAttachments.length
              ? 'linear-gradient(180deg, #fff 70%, #a6a6a6 30%)'
              : '#fff'
        }">
        <div class="d-flex justify-content-between">
          <div class="py-2 px-3 bg-white d-flex desktop" [ngStyle]="{
              'border-bottom-right-radius':
                document.typeId === 1 && activeFile === 0 ? '5px' : '0'
            }" id="box-left">
            <button class="mr-2 ml-2" color="primary" mat-icon-button (click)="tongleFullviewPdf()">
              <mat-icon [hidden]="isFullviewPdf" class="fullview-icon" matTooltip="{{
                  'enterprise_contract.tooltips.btn_expand_more' | translate
                }}">
                arrow_back_ios
              </mat-icon>
              <mat-icon [hidden]="!isFullviewPdf" class="fullview-icon" matTooltip="{{
                  'enterprise_contract.tooltips.btn_expand_less' | translate
                }}">
                arrow_forward_ios
              </mat-icon>
            </button>
          </div>
          <div class="d-flex" id="box-center" style="width: 10%" *ngIf="document.typeId === 1 || document.typeId === 0">
            <div style="width: 100%; position: relative; height: 52px">
              <div class="d-flex box-tab" style="
                  position: absolute;
                  width: 100%;
                  top: 0.5rem;
                  left: 0;
                  height: calc(52px - 0.5rem);
                ">
                <div class="px-2 py-2 tab" *ngFor="
                    let file of document.mainContractAttachments;
                    let i = index
                  " [class.active]="i === activeFile" [class.left]="i === activeFile - 1"
                  [class.right]="i === activeFile + 1" (click)="changeFile(file.path, i)"
                  [class.border-right]="i !== document.mainContractAttachments.length - 1 && i !== activeFile && i !== activeFile - 1"
                  [matTooltip]="file.fileName">

                  <div class="name">
                    <i nz-icon [nzType]="'loading'" *ngIf="file.loading"></i>
                    {{ file.fileName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-3 py-2 bg-white" style="
              display: flex;
              justify-content: flex-end;
              align-items: center;
            " [ngStyle]="{
              'border-bottom-left-radius':
                document.typeId === 1 &&
                activeFile === document.mainContractAttachments.length - 1
                  ? '5px'
                  : '0'
            }" id="box-right">
            <button (click)="doPrint()" mat-stroked-button class="mr-2 btn-download-file-sm desktop" color="primary">
              <mat-icon class="mr-0">print</mat-icon>
              {{ "enterprise_contract.buttons.print" | translate }}
            </button>
            <button mat-stroked-button class="btn-download-file-sm desktop" color="primary"
              (click)="openPDFByBrowser(document.id)">
              <mat-icon class="mr-0">save_alt</mat-icon>
              {{ "enterprise_contract.buttons.download" | translate }}
            </button>
            <button class="ml-2 btn-copy-file-sm desktop" mat-stroked-button color="primary"
                *ngIf="
                    ((document.typeId == documentForm &&
                      takeInfo == null &&
                      !document.isDifferentEnterprise &&
                      !warningContractQuantity &&
                      mediaBreakpoint !== SCREEN_SIZE.XS &&
                      mediaBreakpoint !== SCREEN_SIZE.SM) ||
                    typeCopy === documentUpload)"
                (click)="copyDocument(document.id)"
                [disabled]="commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">file_copy</mat-icon>
              {{ "enterprise_contract.buttons.copy" | translate }}
            </button>
            <button mat-icon-button class="btn-download-file-sm mobile" color="primary"
              (click)="openPDFByBrowser(document.id)">
              <mat-icon class="mr-0">save_alt</mat-icon>
            </button>
          </div>

          <!-- <div class="col-12 col-sm-3 pr-075"
            [matTooltip]="documentParentName ? document.name + ' - ' + documentParentName : document.name">
            <strong> {{document.name}} </strong>
            <strong *ngIf="document.parentId"> - {{documentParentName}} </strong>
          </div>
          <div class="col-12 col-sm-9 text-right pr-075">
            <button mat-stroked-button color="primary" (click)="openPDFByBrowser(document.id)">
              <mat-icon class="mr-0">save_alt</mat-icon>
              {{'enterprise_contract.buttons.download' | translate}}
            </button>
            <button class="ml-3" mat-stroked-button color="primary"
              *ngIf="document.typeId == documentForm && takeInfo == null && !document.isDifferentEnterprise && !warningContractQuantity && !deviceService.isMobile()"
              (click)="copyDocument(document.id)">
              <mat-icon class="mr-0">file_copy</mat-icon>
              {{'enterprise_contract.buttons.copy' | translate}}
            </button>
          </div> -->
        </div>
      </div>

      <div class="parent-document" style="display: flex; justify-content: space-between" [class.landscape]="isViewLandscape">
        <!-- <div id="preview" class="preview-main scrollbar" *ngIf="document.typeId === documentUpload || document.status !== EnumContractStatus.DRAFT"> -->
        <!--        <div id="preview" class="preview-main scrollbar">-->
        <!--          <div class="thumbnailpage {{item.isActive ? 'highlight' : ''}}" *ngFor="let item of thumbnail"-->
        <!--            id="page{{item.page}}" (click)="onClickThumbnailpage(item.page)">-->
        <!--            <img src="{{item.url}}" style="width: 100%">-->
        <!--            <span class="pagenumber" style="display: none;">{{item.page}}</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="document scrollbar_scontract_xs" #navigation id="navigation" tabindex="0"
          style="height: calc(100vh - 220px); width: 100%">
          <div>
            <ng-container>
              <ng-container *ngIf="pdfSrc && !isShowReferencePdf">
                <ngx-extended-pdf-viewer [src]="pdfSrc" [(page)]="pageCurrent"
                  (textLayerRendered)="textLayerRendered($event)" [(zoom)]="zoomLevel" useBrowserLocale="true"
                  height="80vh" [enablePrint]="false" [showDownloadButton]="false" [sidebarVisible]="true"
                  [showRotateButton]="false" [showOpenFileButton]="false" [showBookmarkButton]="false"
                  [showPropertiesButton]="false" [showUnverifiedSignatures]="true" [theme]="'dark'"
                  [language]="language" [showSecondaryToolbarButton]="false" [showSidebarButton]="isShowSidebarButton"
                  [textLayer]="true" [httpHeaders]="authorization">
                </ngx-extended-pdf-viewer>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <hr style="margin: 0" />

      <p
        class="alert-count-otp text-center py-2 m-0"
        [innerHTML]="countOtpText"
      ></p>
    </div>

    <div class=" bg-white text-center mat-elevation-z0 py-2 w-100">
      <button mat-stroked-button color="primary" class="btn mr-3" type="button" (click)="onBackClick()">
        <mat-icon class="mr-0">arrow_back</mat-icon>
        {{ "form.back" | translate }}
      </button>
      <button mat-raised-button color="primary" class="btn mr-3" (click)="startSignFlow()" *ngIf="!hideButton">
        <mat-icon class="mr-0">gesture</mat-icon>
        {{ "button.sign_confirm" | translate }}
      </button>
    </div>

    <div class="scontract-btn-mobile bg-white text-center shadow-lg rounded">
      <ngx-slick-carousel #btnView class="carousel" #slickModal="slick-carousel" [config]="slideButtonConfig">
        <div ngxSlickItem class="flex-fill slide" (click)="onBackClick()">
          <mat-icon>arrow_back</mat-icon>
          <h6 class="mb-0">{{ "form.back" | translate }}</h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="tongleFullviewPdf()">
          <mat-icon *ngIf="!isFullviewPdf">fullscreen</mat-icon>
          <mat-icon *ngIf="isFullviewPdf">info</mat-icon>
          <h6 class="mb-0" *ngIf="isFullviewPdf">{{ 'enterprise_contract.tooltips.info_tab' | translate }}</h6>
          <h6 class="mb-0" *ngIf="!isFullviewPdf">{{ 'enterprise_contract.tooltips.view_document' | translate }}</h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="startSignFlow()" *ngIf="!hideButton">
          <mat-icon>gesture</mat-icon>
          <h6 class="mb-0">
            {{ "button.sign_confirm" | translate }}
          </h6>
        </div>
      </ngx-slick-carousel>
    </div>
  </div>

</div>

<mat-card *ngIf="!isCheckAccessToContract || !isCheckAccessToConfirmContract">
  <mat-card-content class="mb-3">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" style="height: calc(100vh - 104px)">
        <div class="container">
          <div class="row" style="padding-top: 50px">
            <div class="col-11 offset-1 text-center">
              <h4>{{ "alert.page_not_found_no_access" | translate }}</h4>
              <h4>
                {{ "alert.back_home_no_access" | translate }}
              </h4>
              <button mat-stroked-button color="primary" type="button" (click)="goBack()">
                <mat-icon class="mr-0">arrow_back</mat-icon>
                {{ "alert.back_history" | translate }}
              </button>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
